import styles from "./css/Card.module.css";

interface CardProps {
  character: {
    character_name: string;
    world_name: string;
    character_class: string;
    character_level: number;
    character_image: string;
  };
  onClick: () => void;
}

export default function Card({ character, onClick }: CardProps) {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.imageContainer}>
        <img src={character.character_image} alt={character.character_name} />
      </div>
      <div className={styles.info}>
        <div className={styles.nameLevel}>
          <span className={styles.name}>{character.character_name}</span>
          <span className={styles.level}> Lv.{character.character_level}</span>
        </div>
        <div className={styles.world}>{character.world_name}</div>
        <div className={styles.class}>{character.character_class}</div>
      </div>
    </div>
  );
}
